export default __webpack_public_path__ + "static/home_mockup-def22d6c29193d9e60a6538560fc40df.png";